<!--<editor-fold desc="Modals">-->
<ng-template
    #employeeTypeModal
    let-modal
>
  <div class="modal-content">
    <div class="modal-header">
      <p class="modal-title font-16 mb-0 text-dark">
        <span>{{ 'employees.change_type' | translate }}</span>
      </p>
      
      <button
          (click)="modal.dismiss()"
          aria-label="Close"
          class="close"
      >
          <span
              aria-hidden="true"
              class="font-24 text-muted"
          >
            <i class="mdi mdi-close"></i>
          </span>
      </button>
    </div>
    
    <div class="modal-body">
      <form
          (ngSubmit)="onEmployeeTypeSubmit()"
          [formGroup]="employeeTypeForm"
      >
        
        <div class="row">
          <div class="col-12">
            <div class="form-group">
              <label>{{ 'employees.type' | translate }}</label>
              <ng-select [class.is-invalid]="submitted && f.type?.errors" [clearable]="false" class="custom" formControlName="type">
                <ng-option *ngFor="let type of employeeTypes$ | async" [value]="type">
                  {{ ('employees.type_' + type) | translate }}
                </ng-option>
              </ng-select>
            </div>
          </div>
        </div>
        
        <div *ngIf="changeToCommon()" class="row">
          <div class="col-12">
            <div class="form-group">
              <label class="control-label">
                <span>{{ 'employees.role' | translate }}</span>
              </label>
              <ng-select [items]="employeeRoles$ | async" bindLabel="name" bindValue="role_ID" class="custom" formControlName="role" placeholder="Vyberte roli"></ng-select>
              <div *ngIf="submitted && f.role.errors">
                <p *ngIf="f.role.errors.required" class="text-danger validation-text">
                  <span>{{ 'angular_validation.field' | translate }} </span>
                  <span>{{ 'employees.role' | translate }} </span>
                  <span>{{ 'angular_validation.required' | translate }}</span>
                </p>
              </div>
            </div>
          </div>
        </div>
        
        <div *ngIf="changeToCommon()" class="row">
          <div class="col-6">
            <label class="control-label">{{ 'employees.is_active' | translate }}</label>
          </div>
          <div class="col-6 text-right align-self-center">
            <div>
              <input data-switch="success" formControlName="is_active" id="is_active" name="is_active" type="checkbox">
              <label for="is_active">&nbsp;</label>
            </div>
          </div>
        </div>
        
        <div class="row mt-2">
          <div class="col-12 text-right">
            <small class="text-muted">
              <span>{{ 'employees.change_role_description' | translate }}</span>
            </small>
          </div>
        </div>
        
        <div class="row mt-2">
          <div class="col-12 text-right">
            <button class="btn btn-primary">
              <span>{{ 'employees.action_change_employee_type' | translate }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>

<ng-template
    #requestEmployeeChangeDataModal
    let-modal
>
  <div class="modal-content">
    <div class="modal-header">
      <p class="modal-title font-16 mb-0 text-dark">
        <span>{{ 'employees.request_employee_to_change_data' | translate }}</span>
      </p>
      
      <button
          (click)="modal.dismiss()"
          aria-label="Close"
          class="close"
      >
          <span
              aria-hidden="true"
              class="font-24 text-muted"
          >
            <i class="mdi mdi-close"></i>
          </span>
      </button>
    </div>
    
    <div class="modal-body">
      <form #form
            (ngSubmit)="onRequestEmployeeToUpdateDataSubmit()"
            [formGroup]="requestEmployeeChangeDataForm"
      >
        <div class="mb-4">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label class="control-label">
                  <span>{{ 'employees.selected_widget_template' | translate }}</span>
                </label>
                
                <ng-select
                    (change)="widgetTemplateChanged($event)"
                    [clearable]="false"
                    [closeOnSelect]="true"
                    [items]="widgetTemplates$ | async"
                    [multiple]="false"
                    bindLabel="name"
                    bindValue="id"
                    class="custom"
                    formControlName="widget_template_ID"
                >
                </ng-select>
              </div>
            </div>
          </div>
          <div class="row mb-1">
            <div class="col-12">
              <div class="form-group">
                <label class="control-label" for="message">
                  <span>{{ 'employees.message_for_employee' | translate }}</span>
                </label>
                <input
                    #summernote [ngxSummernote]="summernoteHelper.getSummernoteConfig(100, summernote)" class="form-control"
                    formControlName="require_update_message"
                    id="message"
                    name="require_update_message"
                    type="text"
                >
              </div>
            </div>
          </div>
        </div>
        
        
        <div class="row">
          <div class="col-12 text-right">
            <button
                [disabled]="isButtonDisabled()"
                class="btn btn-primary">
              <span>{{ 'employees.action_request_employee_to_change_data' | translate }}</span>
            </button>
          </div>
        </div>
      </form>
    </div>
  </div>
</ng-template>
<!--</editor-fold desc="Modals">-->

<!--<editor-fold desc="Prev & next employee">-->
<ng-container *ngIf="employee;">
  <div class="prev-next-employee">
                <span *ngIf="employee.prev_next?.prev as prev">
                    <i class="mdi mdi-chevron-left"></i>
                    <span (click)="navigateToEntity(prev.employee_ID)">{{ prev.fullname }}</span>
                </span>
    <span *ngIf="employee.prev_next?.prev && employee.prev_next?.next" class="mr-3 space"></span>
    <span *ngIf="employee.prev_next?.next as next">
                    <span (click)="navigateToEntity(next.employee_ID)">{{ next.fullname }}</span>
                    <i class="mdi mdi-chevron-right"></i>
                </span>
  </div>
</ng-container>
<!--</editor-fold>-->

<!--<editor-fold desc="Top 3 cards">-->
<ng-container *ngIf="employee">
  <div *ngIf="employee.states.joining || employee.states.checklist || employee.states.change_request || employee.states.testing_end || employee.states.position_end || employee.states.termination_period || isTerminatedInPast()" class="mb-3">
    <div *ngIf="employee.states.joining" class="alert d-block employee-state-1 mb-2 w-100 shadow">
      <span> {{ 'employees.joining_alert_text' | translate }} </span>
    </div>
    <div *ngIf="employee.states.checklist" class="alert d-block employee-state-2 mb-2 w-100 shadow">
      <span> {{ 'employees.checklist_alert_text' | translate }} </span>
    </div>
    <div *ngIf="employee.states.change_request" class="alert d-block employee-state-3 mb-2 w-100 shadow">
      <span> {{ 'employees.change_request_alert_text' | translate }} </span>
    </div>
    <div *ngIf="employee.states.testing_end" class="alert d-block employee-state-4 mb-2 w-100 shadow">
      <span> {{ 'employees.testing_end_alert_text' | translate }} </span>
    </div>
    <div *ngIf="employee.states.position_end" class="alert d-block employee-state-5 mb-2 w-100 shadow">
      <span> {{ 'employees.position_end_alert_text' | translate }} </span>
    </div>
    <div *ngIf="canTerminate && employee.states.termination_period" class="alert d-block employee-state-6 mb-2 w-100 shadow">
      <span> {{ 'employees.terminate_alert_text' | translate }}. </span>
      <span><u (click)="openTerminationModal(employee)"> {{ 'employees.terminate_alert_button' | translate }}</u>.</span>
    </div>
    <div *ngIf="isTerminatedInPast()" class="alert d-block employee-state-6 mb-2 w-100 shadow">
      <span> {{ 'employees.terminated_alert_text' | translate }}. </span>
      <span><u (click)="openTerminationModal(employee)"> {{ 'employees.terminate_alert_button' | translate }}</u>.</span>
    </div>
  </div>
</ng-container>

<app-employee-attendance-stats (fetchEmployeeExtendedFn)="fetchEmployeeExtended$.next()"
                               *ngIf="employeeID && employee$"
                               [employee$]="employee$"
                               [employeeID]="employeeID"
                               [placement]="'EMPLOYEE'"
></app-employee-attendance-stats>

<app-employee-onboardings *ngIf="(availableWidgets$ | async)?.employee?.overview?.onboardings && checkPermissions(['onboarding'])"></app-employee-onboardings>
<!--</editor-fold>-->

<!--<editor-fold desc="Employee profile">-->
<div class="row">
  <div class="col-12">
    <div
        *ngIf="profileLoaded; else loadingProfileTemplate"
        class="row"
        id="employee_info"
    >
      
      <div class="col-lg-12">
        <div
            class="card shadow"
        >
          <app-help name="employee.detail.personal_info"></app-help>
          
          <div class="card-header card-header--padding employee-overview" id="employee-menu">
            <div class="row d-flex">
              <div class="col">
                <div class="d-flex align-items-start">
                  <div [ngClass]="{'hovereffect': checkPermissions(['employee'], 'edit')}"
                       class="avatar-wrapper">
                    <img [src]="employee.avatar" alt="User's avatar" class="avatar-image"/>
                    <div (click)="openAvatarChangeModal()" *ngIf="checkPermissions(['employee'], 'edit')" class="overlay rounded-circle d-flex justify-content-center align-items-center">
                      <span class="info"><i class="mdi mdi-pencil"></i></span>
                    </div>
                  </div>
                  <div class="d-none d-md-block">
                    <ng-container [ngTemplateOutlet]="employeeOverviewHeadingTemplate"></ng-container>
                  </div>
                </div>
              </div>
              
              <div class="col-auto text-right">
                <button
                    (click)="openEmployeeActiveAccessModal()"
                    *ngIf="canEdit"
                    class="btn btn-light btn-icon font-12 mr-2"
                >
                  <i *ngIf="employee?.has_active_access && !employee?.has_active_invitation"
                     [ngbTooltip]="('employees.access_to_application' | translate) + (employee?.has_active_access_to ? (employee?.has_active_access_to | date:'dd.MM.yyyy') : '')"
                     class="mdi mdi-key-variant mdi-24px text-green">
                  </i>
                  <i *ngIf="!employee?.has_active_access"
                     [ngbTooltip]="('employees.no_active_access_tooltip' | translate)"
                     class="mdi mdi-key-variant mdi-24px text-danger">
                  </i>
                  <i *ngIf="employee?.has_active_access && employee?.has_active_invitation"
                     [ngbTooltip]="('employees.has_active_invitation_text' | translate)"
                     class="mdi mdi-key-variant mdi-24px text-warning">
                  </i>
                </button>
                <button (click)="syncToAbra()"
                        *ngIf="integrationAbraActive && canEdit"
                        [ngbTooltip]="('employees.sync_to_abra' | translate)"
                        class="btn btn-light btn-icon mr-2">
                  <img [src]="'assets/images/integrations/abra.png'" alt="abra" style="height:30px;"/>
                </button>
                <div
                    *ngIf="canArchive || canTerminate || canUnarchive"
                    class="dropdown notification-list d-inline-block mr-2"
                    ngbDropdown
                >
                  <button
                      class="btn btn-light btn-icon font-12"
                      id="dropdownBasic1"
                      ngbDropdownToggle
                  >
                    <i class="mdi mdi-dots-vertical mdi-24px"></i>
                  </button>
                  
                  <div
                      aria-labelledby="dropdownBasic1"
                      class="dropdown-menu dropdown-menu-right dropdown-menu-animated topbar-dropdown-menu profile-dropdown fadeIn animated faster shadow"
                      ngbDropdownMenu
                  >
                    <ng-container [ngTemplateOutlet]="dropdownMenu"></ng-container>
                  </div>
                </div>
                <button
                    (click)="openEmployeeEditModal()"
                    *ngIf="canEdit && !employee.is_archived"
                    [updateButton]="'employees.action_edit' | translate"
                ></button>
              </div>
            </div>
            <div class="d-block d-md-none mt-2">
              <div class="col-12">
                <ng-container [ngTemplateOutlet]="employeeOverviewHeadingTemplate"></ng-container>
              </div>
            </div>
          </div>
          
          <div *ngIf="availableRoutes.length > 0; else loadingMenuTemplate" class="employee-horizontal-menu d-none d-lg-block">
            <div *ngFor="let r of availableRoutes; last as isLast" class="employee-horizontal-menu-item-wrap">
              <a
                  [routerLink]="r.routerLink"
                  class="employee-horizontal-menu-item text-nowrap text-muted"
                  fragment="employee-menu"
                  routerLinkActive="employee-horizontal-menu-item--active"
              >
                <span>{{ r.title }}</span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<!--</editor-fold desc="Employee profile">-->

<!--<editor-fold desc="Routes mobile dropdown">-->
<div class="row mb-2 d-lg-none"
>
  <div class="col-12">
    <div
        #dropdown="ngbDropdown"
        class="submenu-dropdown shadow"
        ngbDropdown
    >
      <button
          class="btn btn-block btn-link"
          id="dropdownBasic2"
          ngbDropdownToggle
      >
        <span class="text-center">{{ pageTitle$ | async | translate }}</span>
        
        <span class="float-right mr-2">
          <i
              *ngIf="!dropdown.isOpen()"
              class="mdi mdi-chevron-down mdi-18px"
          ></i>
          <i
              *ngIf="dropdown.isOpen()"
              class="mdi mdi-chevron-up mdi-18px"
          ></i>
        </span>
      </button>
      
      <div
          aria-labelledby="dropdownBasic2"
          class="w-100"
          id="dropdownMenu"
          ngbDropdownMenu
      >
        <ng-container *ngFor="let r of availableRoutes">
          <a
              [routerLink]="r.routerLink"
              class="btn btn-block"
              fragment="employee-menu"
              ngbDropdownItem
              routerLinkActive="active">
            {{ r.title }}
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<ng-template #employeeOverviewHeadingTemplate>
  <div class="w-100 overflow-hidden">
    <p class="d-flex align-items-start modal-title text-dark pt-0">
      <span class="employee-overview-heading">
    <span>
        <span class="employee-overview-title">{{ employee.fullname }}</span>
      <ng-container *ngIf="employee.abbreviation || employee.personal_code">
        (<span *ngIf="employee.personal_code">{{ employee.personal_code }}</span>
        <span *ngIf="employee.personal_code && employee.abbreviation">, </span>
        <span *ngIf="employee.abbreviation">{{ employee.abbreviation }}</span>)
      </ng-container>
    </span>
    <ng-container *ngIf="employee.facebook">
      <span>&nbsp;</span>
      <span><a href="{{ employee.facebook }}" target="_blank"><i class="mdi mdi-facebook mdi-18px"></i></a></span>
    </ng-container>
    <ng-container *ngIf="employee.linkedin">
      <span>&nbsp;</span>
      <span><a href="{{ employee.linkedin }}" target="_blank"><i class="mdi mdi-linkedin mdi-18px"></i></a></span>
    </ng-container>
        <span *ngIf="employee.is_archived">
        <strong class="text-danger">
          <span>&nbsp;</span>
          <span>{{ 'employees.archived' | translate }}</span>
        </strong>
      </span>
      <span *ngIf="employee.employee_type === 'POTENTIAL'">
        <strong class="text-primary mr-1">
          <span>&nbsp;</span>
          <span>{{ 'employees.potential' | translate }}</span>
        </strong>
        <button
            (click)="openEmployeeTypeModal()"
            *ngIf="employee.employee_type === 'POTENTIAL'"
            class="btn btn-icon btn-light btn-sm editButton"
        ><i class="mdi mdi-pencil"></i></button>
      </span>
  </span>
    </p>
    
    <div class="employee-overview-info-rows">
      <div class="pt-2"><i class="text-muted mdi mdi-briefcase"></i>
        {{ employee.position || ('employees.no_position' | translate) }}
        <span *ngIf="employee.upcoming_position">({{ employee.upcoming_position }})</span>
      </div>
      <div>
        <span class="show-button-on-hover">
          <i class="text-muted mdi mdi-account-group"></i>
          {{ employee?.team ?? ('employees.no_team' | translate) }}
          <button (click)="openEmployeeChangeCompanyGroupModal()" *ngIf="canEdit && !employee.is_archived" class="btn btn-icon btn-light btn-sm editButton showed-on-hover">
            <i class="mdi mdi-pencil"></i>
          </button>
        </span>&nbsp;&nbsp;&nbsp;
        <span class="show-button-on-hover">
          <i class="text-muted mdi mdi-account-arrow-up"></i>
          {{ employee?.supervisor?.fullname ?? ('employees.no_supervisor' | translate) }}
          <button (click)="openEmployeeSupervisorModal()" *ngIf="canEdit && !employee.is_archived" class="btn btn-icon btn-light btn-sm editButton showed-on-hover">
            <i class="mdi mdi-pencil"></i>
          </button>
        </span>
      </div>
      <div>
        <span *ngIf="employee.email"><i class="text-muted mdi mdi-email"></i> {{ employee.email }}</span>
        <span *ngIf="employee.phone && employee.email">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
        <span *ngIf="employee.phone"><i class="text-muted mdi mdi-phone"></i> {{ employee.phone }}</span>
      </div>
      <app-tag-list *ngIf="checkPermissions(['tag'])"
                    [entityID]="employee.employee_ID"
                    [entityType]="'Employee'">
      </app-tag-list>
      <ng-container *ngIf="employee.custom_fields.length > 0">
        <span *ngFor="let field of employee.custom_fields" class="text-muted custom-field text-overflow-ellipsis">
          <span><i class="mdi mdi-form-textbox"></i></span>
          <span> {{ field.label }}: </span>
          <ng-container [ngSwitch]="field.type">
            <span *ngSwitchCase="'RICHTEXT'" [innerHTML]="field.value"></span>
            <span *ngSwitchCase="'PERCENT'"> {{ field.value }} % </span>
            <span *ngSwitchCase="'AMOUNT'"> {{ field.value | localizedCurrency }} </span>
            <span *ngSwitchCase="'DATE'"> {{ field.value | date: 'dd.MM.yyyy' }} </span>
            <span *ngSwitchCase="'DATETIME'"> {{ field.value | date: 'dd.MM.yyyy HH:mm' }} </span>
            <span *ngSwitchCase="'TOGGLE'">  {{ (field.value ? 'global.YES' : 'global.NO') | translate }} </span>
            <span *ngSwitchDefault> {{ field.value }} </span>
          </ng-container>
        </span>
      </ng-container>
    </div>
  </div>
</ng-template>

<ng-template #dropdownMenu>
  <button
      (click)="downloadProfilePdf(employee.employee_ID, employee.fullname)"
      *ngIf="canViewPersonalData"
      ngbDropdownItem
  >{{ 'employees.action_download_profile' | translate }}
  </button>
  
  <button
      (click)="openTerminationModal(employee)"
      *ngIf="canTerminate"
      ngbDropdownItem
  >{{ 'employees.terminate_employment' | translate }}
  </button>
  
  <button
      (click)="unarchiveEmployee()"
      *ngIf="canUnarchive"
      ngbDropdownItem
  >{{ 'employees.action_remove_from_archive' | translate }}
  </button>
  
  <button
      (click)="archiveEmployee()"
      *ngIf="canArchive"
      ngbDropdownItem
  >{{ 'employees.action_archive' | translate }}
  </button>
  
  <button
      (click)="openActivityModal()"
      *ngIf="canEdit"
      ngbDropdownItem
  >{{ 'employees.action_create_activity' | translate }}
  </button>
  
  <button
      (click)="openEmployeeTypeModal()"
      *ngIf="canEdit"
      ngbDropdownItem
  >{{ 'employees.change_type' | translate }}
  </button>
  
  <button
      *ngIf="canEdit"
      [routerLink]="['/employee', employee.employee_ID, 'detail', 'setting']"
      ngbDropdownItem
  >{{ 'employees.change_role' | translate }}
  </button>
  
  <button
      (click)="openRequestEmployeeChangeDataModal()"
      *ngIf="canEdit"
      ngbDropdownItem
  >{{ 'employees.request_employee_to_change_data' | translate }}
  </button>
  
  <button
      (click)="loginAsThisEmployee(employee)"
      *ngIf="isAdmin"
      ngbDropdownItem
  >{{ 'employees.login_as_this_employee' | translate }}
  </button>
  
  <button
      (click)="deleteEmployee()"
      *ngIf="canDelete"
      ngbDropdownItem
  >{{ 'employees.action_delete' | translate }}
  </button>
</ng-template>
<!--</editor-fold desc="Routes mobile dropdown">-->

<!--<editor-fold desc="Desktop menu & router outlet">-->
<div class="row">
  <div class="col-12">
    <div>
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!--</editor-fold desc="Desktop menu">-->

<!--<editor-fold desc="Loading templates">-->
<ng-template #loadingProfileTemplate>
  <div class="card shadow p-3">
    <div class="fb-item">
      <div class="first-section-wrapper d-flex align-items-center">
        <div class="gravatar mr-3">
          <ngx-skeleton-loader
              [theme]="{ width: '80px', height: '80px' }"
              appearance="circle"
          >
          </ngx-skeleton-loader>
        </div>
        <div class="gravatar-title pt-3">
          <div>
            <ngx-skeleton-loader
                [theme]="{ width: '200px' }"
            ></ngx-skeleton-loader>
          </div>
          <div>
            <ngx-skeleton-loader
                [theme]="{ width: '170px' }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
      <div class="second-section-wrapper">
        <div class="item">
          <ngx-skeleton-loader [theme]="{ 'margin': '15px 0' }"
                               appearance="line"
                               count="3">
          </ngx-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #loadingMenuTemplate>
  <div class="card h-100 shadow">
    <div class="card-body px-4 py-0">
      <div *ngFor="let r of allRoutes; last as isLast">
        <div
            [class.border-bottom]="!isLast"
            class="row"
        >
          <div class="col-9 pt-4 pb-3 align-self-center">
            <ngx-skeleton-loader
                [theme]="{ width: '100%', 'border-radius': '0', height: '10px' }"
            >
            </ngx-skeleton-loader>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!--</editor-fold desc="Loading templates">-->
